import { CakeSlice } from 'lucide-react';

type EmptyStateProps = {
  title?: string;
  description?: string;
  icon?: React.ReactNode;
  action?: React.ReactNode;
};

const EmptyState = ({
  title = 'Nothing found',
  description = 'There’s currently no data available. Please try again later.',
  icon = <CakeSlice />,
  action,
}: EmptyStateProps) => {
  return (
    <div className="flex min-h-96 flex-col items-center justify-center p-5 text-center">
      {icon}
      <div className="mx-auto max-w-96">
        <p className="mt-2 font-medium">{title}</p>
        <p className="mb-5 text-sm text-muted-foreground">{description}</p>
        {action && <div>{action}</div>}
      </div>
    </div>
  );
};

export default EmptyState;
